// DateRangeSelector.jsx
import React, { useMemo, useState } from 'react'
import {
  startOfWeek,  endOfWeek,   subWeeks,
  startOfMonth, endOfMonth,  subMonths,
  startOfQuarter, endOfQuarter, subQuarters,
  startOfYear,  endOfYear,   subYears,
  format,
  isSameDay,
} from 'date-fns'

const OPTIONS = [
  { label: 'Last week',     fn: now => ({
      from: subWeeks(startOfWeek(now, { weekStartsOn: 1 }), 1),
      to:   subWeeks(endOfWeek(now,   { weekStartsOn: 1 }), 1),
    })
  },
//   { label: 'This month',    fn: now => ({
//       from: startOfMonth(now),
//       to:   endOfMonth(now),
//     })
//   },
//   { label: 'This quarter',  fn: now => ({
//       from: startOfQuarter(now),
//       to:   endOfQuarter(now),
//     })
//   },
//   { label: 'This year',     fn: now => ({
//       from: startOfYear(now),
//       to:   endOfYear(now),
//     })
//   },
  { label: '2 weeks ago',   fn: now => ({
      from: subWeeks(startOfWeek(now, { weekStartsOn: 1 }), 2),
      to:   subWeeks(endOfWeek(now,   { weekStartsOn: 1 }), 2),
    })
  },
//   { label: 'Last month',    fn: now => ({
//       from: startOfMonth(subMonths(now, 1)),
//       to:   endOfMonth(subMonths(now, 1)),
//     })
//   },
//   { label: 'Last quarter',  fn: now => ({
//       from: startOfQuarter(subQuarters(now, 1)),
//       to:   endOfQuarter(subQuarters(now, 1)),
//     })
//   },
//   { label: 'Last year',     fn: now => ({
//       from: startOfYear(subYears(now, 1)),
//       to:   endOfYear(subYears(now, 1)),
//     })
//   },
]

function formatLabelRange(from, to, label) {
  // For months, show "MMM yyyy"; everything else full dd MMM – dd MMM yyyy
  if (label.toLowerCase().includes('month')) {
    return format(from, 'MMM yyyy')
  }
  return `${format(from, 'dd MMM')} – ${format(to, 'dd MMM yyyy')}`
}

export default function DateRangeSelector({ startDate, endDate, onChange }) {
  const now = useMemo(() => new Date(), [])
  const [isOpen, setIsOpen] = useState(false)

  // Build a list of computed ranges
  const dateRanges = useMemo(
    () =>
      OPTIONS.map(opt => {
        const { label, fn } = opt
        const { from, to } = fn(now)
        return {
          labelPart:  label,
          datePart:   formatLabelRange(from, to, label),
          from,
          to,
        }
      }),
    [now]
  )

  // Which one is currently active?
  const selected = useMemo(() => {
    const match = dateRanges.find(
      r =>
        startDate &&
        endDate &&
        isSameDay(r.from, startDate) &&
        isSameDay(r.to, endDate)
    )
    // fallback to first if nothing matches
    return match || dateRanges[0]
  }, [dateRanges, startDate, endDate])

  const toggleDropdown = () => setIsOpen(open => !open)

  const handleSelect = ({ from, to }) => {
    onChange(from, to)
    setIsOpen(false)
  }

  return (
    <div className="relative w-full">
      <button
        onClick={toggleDropdown}
        className="block w-full text-left bg-white text-gray-700 font-thin py-3 px-4 rounded-lg cursor-pointer appearance-none leading-tight focus:outline-none focus:bg-white focus:border-gray-500 border-gray-700"
      >
        {selected.labelPart} | {selected.datePart}
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <i className={`fas fa-angle-${isOpen ? 'up' : 'down'} text-gray-500`} />
        </div>
      </button>

      <ul
        className={`absolute left-0 mt-2 w-full bg-white shadow-lg rounded-md border-b border-gray-300 z-50 text-sm ${
          !isOpen ? 'hidden' : ''
        }`}
      >
        {dateRanges.map((r, idx) => (
          <React.Fragment key={r.labelPart}>
            <li
              onClick={() => handleSelect(r)}
              className="py-2 px-4 flex justify-between cursor-pointer hover:bg-gray-200"
            >
              <span className="font-thin text-gray-700">{r.labelPart}</span>
              <span className="font-thin text-gray-700">{r.datePart}</span>
            </li>
            {idx === 3 && <hr className="my-2 border-gray-300" />}
          </React.Fragment>
        ))}
      </ul>
    </div>
  )
}
